import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';

import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import AboutMe from "./components/AboutMe/AboutMe";
import Contact from "./components/Contact/Contact";
import Portfolio from "./components/Portfolio/Portfolio";
import Aurora from "./components/Aurora/Aurora";

import "./App.css";
import "./i18n";

const App = () => {
  const [isArrowVisible, setIsArrowVisible] = useState(true);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t("meta.title");
    document.querySelector('meta[name="description"]').setAttribute('content', t("meta.description"));
  }, [t, i18n.language]);

  const homeRef = useRef(null);
  const aboutMeRef = useRef(null);
  const contactRef = useRef(null);
  const portfolioRef = useRef(null);

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollPosition + windowHeight >= documentHeight - 50) {
      setIsArrowVisible(false);
    } else {
      setIsArrowVisible(true);
    }
  };

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Header
        scrollToHome={() => scrollToSection(homeRef)}
        scrollToAboutMe={() => scrollToSection(aboutMeRef)}
        scrollToPortfolio={() => scrollToSection(portfolioRef)}
        scrollToContact={() => scrollToSection(contactRef)}
      />
      <div>
        <div ref={homeRef}>
          <Home scrollToAboutMe={() => scrollToSection(aboutMeRef)} />
        </div>
        <div ref={aboutMeRef}>
          <AboutMe scrollToPortfolio={() => scrollToSection(portfolioRef)} />
        </div>
        <div ref={portfolioRef}>
          <Portfolio />
        </div>
        <div ref={contactRef}>
          <Contact scrollToHome={() => scrollToSection(homeRef)} />
        </div>
        {isArrowVisible && <div className="arrow" />}
        <Aurora
          colorStops={["#3A29FF", "#FF94B4", "#FF3232"]}
          blend={0.5}
          amplitude={1.0}
          speed={0.5}
        />
      </div>
    </>
  );
};

export default App;
